import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=9b59009a&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b59009a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b59009a')) {
      api.createRecord('9b59009a', component.options)
    } else {
      api.reload('9b59009a', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=9b59009a&scoped=true", function () {
      api.rerender('9b59009a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/UserForm.vue"
export default component.exports